<app-page
  pageTitle="Oops! Something went wrong..."
  [subTitle]="errorDescription"
>
  <a class="button" *ngIf="forceRefresh" [href]="returnLink">Refresh</a>
  <a class="button" *ngIf="!forceRefresh" [routerLink]="returnLink">Return</a>
</app-page>
